// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__cOQNQ","links":"Footer_links__LU3rK","link":"Footer_link__DRi5g"};